module.exports = __webpack_public_path__ + "img/two2Orange.a4b64711.jpg";